import React from "react";
import { FEE_SUCCESS_TEXT, FEE_PAYMENT_TEXT } from "../lib/feePolicy";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-heading text-xl md:text-2xl font-bold text-navy mb-3">{title}</h2>
    <div className="text-sm text-foreground/80 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <section className="bg-navy text-white section-pad">
        <div className="container-x">
          <span className="accent-bar mb-4" />
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold tracking-tight">Terms & Conditions</h1>
          <p className="text-white/70 mt-3 text-sm" data-testid="terms-last-updated">Last updated: September 2026</p>
        </div>
      </section>
      <section className="container-x section-pad max-w-4xl">
        <Section title="1. Scope of Services">
          <p>The Client appoints Crew Connect FinInvesto (the "Consultant") to provide financial advisory services, including identifying potential investors and financiers (including Banks, NBFCs, Financial Institutions and other Lenders), assisting with financial modeling, and facilitating negotiations for the purpose of funding.</p>
        </Section>
        <Section title="2. Fees and Commission">
          <p data-testid="terms-success-fee"><strong>Success Fee:</strong> {FEE_SUCCESS_TEXT}</p>
          <p data-testid="terms-fee-payment"><strong>Payment:</strong> {FEE_PAYMENT_TEXT}</p>
        </Section>
        <Section title="3. No Guarantee and Limitation of Liability">
          <p><strong>Not a Guarantor:</strong> The Consultant acts strictly as an advisor. The Consultant is not a guarantor of the Client's financial obligations, debts, or performance. The Consultant shall not be held liable for any default by the Client or any third party involved in the Transaction.</p>
          <p><strong>No Warranty of Outcome:</strong> While the Consultant will use professional efforts, they do not guarantee that a Transaction will be successfully closed or that specific terms will be met.</p>
        </Section>
        <Section title="4. Post-Transaction Responsibility">
          <p><strong>Conclusion of Services:</strong> The Consultant's responsibility ends immediately upon the Closing Date of the Transaction.</p>
          <p><strong>No "After Activity" Liability:</strong> The Consultant is not responsible for any "after activity," including the subsequent management, operational success, or reporting requirements of the Client. The Consultant shall not be involved in, or liable for, the ongoing relationship between the Client and the investor/lender post-closing.</p>
        </Section>
        <Section title="5. Non-Circumvention">
          <p>The Client agrees not to engage directly with any parties introduced by the Consultant with the intent to bypass the commission structure. This protection remains in effect for <strong>24 (twenty-four) months</strong> following the termination of this agreement.</p>
        </Section>
        <Section title="6. Confidentiality">
          <p>All financial data and proprietary information shared between the parties shall remain strictly confidential and shall not be disclosed to third parties without prior written consent, except as required by law.</p>
        </Section>
        <Section title="7. Governing Law">
          <p>This Mandate shall be governed by the laws of India, with exclusive jurisdiction of the courts in the State of Delhi.</p>
        </Section>
        <Section title="8. Acceptance">
          <p>By engaging with Crew Connect FinInvesto — including but not limited to submitting a lead form, downloading our brochure, or signing a service agreement — you acknowledge that you have read, understood and agreed to these Terms & Conditions.</p>
        </Section>
      </section>
    </div>
  );
}
